import React, { useState,useEffect } from "react";
import { useParams,Link } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitleButton from "../components/includes/HeaderBranchTitleButton";

import { addThousandPoint} from "../../components/common/Common";

import "../../css/style.css";

//정산세부내역
const TextBookShow = () => {
  const {st_idx,tb_month } = useParams();
  const branch_idx = Number(localStorage.getItem('branch_idx'));
  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  const [varBookOrderInfo,setBookOrderInfo] = useState({});
  const [varBookOrderList,setBookOrderList] = useState([]);

  //정산세부내역 호출
  const GetTextBookInformation = async() => {
    const sendData = {bh_idx:branch_idx,tb_month:tb_month};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_textbook_list`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      //교재주문정보
      setBookOrderInfo(datas.totals);
      setBookOrderList(datas.textbooks);
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});
    GetTextBookInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="vh-content settle-content">
      <HeaderBranchTitleButton varPageTitle={'교재 확인 내역서'} varBackString={`/Branch/SettlementDetail/${st_idx}`} varButtonTitle="교재신청" varButtonLink={'/Branch/TextBookOrder'}/>
      <div className="vh-content-body">
        <div className="textbook-view-wrap">
          <div className="center-wrap">
						<div className="view-tit">{`${tb_month.substr(2,2)}.${tb_month.slice(-2)}`}월 교재 확인 내역서</div>
            <table id="">
              <thead>
                  <tr><th>과목</th><th>단계</th><th>수량</th><th>가격</th><th>계</th></tr>
							</thead>
              <tbody>
                {varBookOrderList.map((orders,i)=>(
                  <tr key={'orders_'+i}>
                    <td>{orders.vb_vt_mode===1?"수/연산":"감각/기하"}</td>
                    <td>{orders.vb_vt_name}</td>
                    <td>{orders.tnumb}</td>
                    <td>{addThousandPoint(orders.vb_price)}</td>
                    <td>{addThousandPoint(orders.vb_price * orders.tnumb)}</td>
                  </tr>
                ))}
                <tr>
									<td colSpan="2">합계</td>
									<td>{addThousandPoint(varBookOrderInfo.totalnumb)}</td>
									<td colSpan="2" style={{textAlign:"right",paddingRight:"15px"}}>{addThousandPoint(varBookOrderInfo.totalamount)}</td>
								</tr>
              </tbody>
            </table>
            <div className="form-contoller bt-btn">
              <Link to={`/Branch/SettlementDetail/${st_idx}`} style={{width:"100%"}} className="form-contoller-btn btn-no">목록</Link>
            </div>
            
          </div>
        </div>
      </div>
    </div>	
  );
}
export default TextBookShow;